import React from "react";
export default function IntroSection() {
  return (
    <section id="intro" className="parallax-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h1 className="wow bounceIn" data-wow-delay="0.9s">Vidya Bharati Khel Parisadh</h1>
            <h3 className="wow fadeInUp" data-wow-delay="1.6s">National Games 2025 - 26</h3>
            <a href="#contact" className="btn btn-lg btn-default smoothScroll wow fadeInUp hidden-xs" data-wow-delay="2.3s">CONTACT US</a>
            <a href="#register" className="btn btn-lg btn-danger smoothScroll wow fadeInUp" data-wow-delay="2.3s">ONLINE ENTRY</a>
          </div>
        </div>
      </div>
    </section>
  );
}
